import { render, staticRenderFns } from "./vxChips.vue?vue&type=template&id=66426f5a&"
import script from "./vxChips.vue?vue&type=script&lang=js&"
export * from "./vxChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports